import { isPlatformBrowser } from '@angular/common';
import type { AfterViewInit, ElementRef } from '@angular/core';
import {
	Component,
	effect,
	inject,
	input,
	output,
	PLATFORM_ID,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import { EventPhase } from '@angular/core/primitives/event-dispatch';

import { cn } from '@valk-nx/core/lib/core';
import { GeneralHelper } from '@valk-nx/helpers/lib/general/general.helper';
import { SVG_ICON_IMPORTS } from '@valk-nx/helpers/lib/svg-unique-ids/svg-unique-ids.directive';

@Component({
	encapsulation: ViewEncapsulation.None,
	selector: 'vp-modal',
	templateUrl: './modal.html',
	imports: [SVG_ICON_IMPORTS],
})
export class ModalComponent implements AfterViewInit {
	private readonly platformId = inject(PLATFORM_ID);
	private isFirstRun = true;

	cn = cn;

	testId = input<string>();
	closeButton = input(true);
	closeOnEscape = input(true);
	closeOnOutsideClick = input(true);
	title = input('');
	showingModal = input.required<boolean>();
	isMaxWScreenLG = input(false);
	showFooter = input(false);

	emitClose = output<void>();

	@ViewChild('dialog') modalRef!: ElementRef<HTMLDialogElement>;
	@ViewChild('footer') footerRef: ElementRef | undefined;

	scrollPosition = 0;

	constructor() {
		effect(() => {
			const showing = this.showingModal();
			if (showing) {
				if (this.isFirstRun) {
					this.isFirstRun = false;
					setTimeout(() => this.showModal());
				} else {
					this.showModal();
				}
			} else {
				if (this.isFirstRun) {
					this.isFirstRun = false;
				} else {
					this.closeModal();
				}
			}
		});
	}

	ngAfterViewInit(): void {
		this.modalRef.nativeElement.addEventListener('cancel', (event) => {
			/* v8 ignore start */
			if (event.eventPhase !== EventPhase.REPLAY) {
				/* v8 ignore stop */
				event.preventDefault();
			}
			/* v8 ignore start */
			if (this.closeOnEscape()) {
				/* v8 ignore stop */
				this.closeModal();
			}
		});

		this.modalRef.nativeElement.addEventListener('click', (event) => {
			/* v8 ignore start */
			if (this.closeOnOutsideClick()) {
				/* v8 ignore stop */
				/* v8 ignore start */
				if (event.target === this.modalRef.nativeElement) {
					/* v8 ignore stop */
					this.closeModal();
				}
			}
		});

		this.modalRef.nativeElement.addEventListener('close', () => {
			this.emitClose.emit();
		});
	}

	showModal(): void {
		/* v8 ignore start */
		if (isPlatformBrowser(this.platformId)) {
			/* v8 ignore stop */
			this.modalRef?.nativeElement.showModal();
			this.scrollPosition = window.scrollY;
			GeneralHelper.bodyLock(true, this.scrollPosition);
		}
	}

	closeModal(): void {
		/* v8 ignore start */
		if (isPlatformBrowser(this.platformId)) {
			/* v8 ignore stop */
			this.modalRef?.nativeElement.close();
			this.emitClose.emit();
			GeneralHelper.bodyLock(false, this.scrollPosition);
		}
	}
}
